<cb-authorized>
    <cb-body>
        <cb-page-header [actions]="controls">
            People
        </cb-page-header>

        <cb-users-list></cb-users-list>
    </cb-body>

</cb-authorized>